import { useEffect, useState } from "react";
import axios from "axios";

function StudentDashboard() {

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [feesIssue, setFeesIssue] = useState(false);
  const [resultsReleased, setResultsReleased] = useState(true);
  const [message, setMessage] = useState("");
  const [lang, setLang] = useState("EN");

  const token = localStorage.getItem("access");

  const t = {
    EN: {
      dashboard: "Student Dashboard",
      logout: "Logout",
      download: "Download Report",
      average: "Average",
      grade: "Grade",
      rank: "Rank",
      subjects: "Subjects",
      subject: "Subject",
      coefficient: "Coefficient",
      total: "Total",
      remark: "Remark",
      teacherRemark: "Teacher's Remark",
      withheld: "Results Withheld",
      loading: "Loading your results...",
      passed: "Subjects Passed",
      promotion: "Promotion Status",
      honorRoll: "Honor Roll",
      promoted: "PROMOTED",
      repeated: "REPEATED",
      scrollNote: "← Scroll to view all columns →"
    },
    FR: {
      dashboard: "Tableau de Bord Élève",
      logout: "Se Déconnecter",
      download: "Télécharger le Bulletin",
      average: "Moyenne",
      grade: "Note",
      rank: "Rang",
      subjects: "Matières",
      subject: "Matière",
      coefficient: "Coefficient",
      total: "Total",
      remark: "Remarque",
      teacherRemark: "Remarque du Professeur",
      withheld: "Résultats Bloqués",
      loading: "Chargement des résultats...",
      passed: "Matières Validées",
      promotion: "Statut de Promotion",
      honorRoll: "Tableau d'Honneur",
      promoted: "PROMU",
      repeated: "REDOUBLANT",

      scrollNote: "← Faites défiler pour voir toutes les colonnes →"
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, [token]);

  const fetchDashboard = async () => {
    try {

      const res = await axios.get(
        "https://api.eduskot.com/api/results/student-dashboard/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.results_released === false) {
        setResultsReleased(false);
        setMessage(res.data.message);
        return;
      }

      if (res.data.fees_issue) {
        setFeesIssue(true);
        setMessage(res.data.message);
      } else {
        setData(res.data);
      }

    } catch (err) {
      console.error(err);
      setMessage("Failed to load results.");
    } finally {
      setLoading(false);
    }
  };

  const downloadReport = async () => {

    try {

      const response = await axios.get(
        "https://api.eduskot.com/api/results/download-report/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob"
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", "report-card.pdf");

      document.body.appendChild(link);
      link.click();
      link.remove();

    } catch (err) {
      console.error(err);
      alert("Failed to download report card.");
    }

  };

  const logout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  if (loading) {
    return <div style={styles.loading}>{t[lang].loading}</div>;
  }

  if (!resultsReleased) {
    return (
      <div style={styles.page}>
        <div style={styles.warningCard}>
          <h2>Results Not Released</h2>
          <p>{message || "Results for this term have not been released yet."}</p>

          <button style={styles.logoutBtn} onClick={logout}>
            {t[lang].logout}
          </button>
        </div>
      </div>
    );
  }

  if (feesIssue) {
    return (
      <div style={styles.page}>
        <div style={styles.warningCard}>
          <h2>⚠ {t[lang].withheld}</h2>
          <p>{message}</p>

          <button style={styles.logoutBtn} onClick={logout}>
            {t[lang].logout}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.page}>

      <div style={styles.header}>

        <h1 style={styles.title}>{t[lang].dashboard}</h1>

        <div style={styles.headerControls}>

          <button style={styles.downloadBtn} onClick={downloadReport}>
            {t[lang].download}
          </button>

          <select
            style={styles.language}
            value={lang}
            onChange={(e) => setLang(e.target.value)}
          >
            <option value="EN">English</option>
            <option value="FR">Français</option>
          </select>

          <button style={styles.logoutBtn} onClick={logout}>
            {t[lang].logout}
          </button>

        </div>

      </div>

      <div style={styles.studentCard}>
        <h2>{data.student}</h2>
        <p>{data.class} • {data.term}</p>
      </div>

      <div style={styles.stats}>

        <div style={{ ...styles.statCard, background: "#2563eb" }}>
          <span>{t[lang].average}</span>
          <h2>{data.average}</h2>
        </div>

        <div style={{ ...styles.statCard, background: "#16a34a" }}>
        <span>{t[lang].passed}</span>
        <h2>
          {data.subjects_passed}/{data.total_subjects}
        </h2>
      </div>

        <div style={{ ...styles.statCard, background: "#f59e0b" }}>
          <span>{t[lang].rank}</span>
          <h2>{data.rank}/{data.class_size}</h2>
        </div>

      </div>

      {data.honor_roll && (

      <div style={styles.honorCard}>

        🏆 HONOR ROLL

        <div style={styles.honorText}>
          Congratulations! You passed all subjects this term.
        </div>

      </div>

    )}



      <div style={styles.tableCard}>

        <h3 style={{ marginBottom: "5px" }}>{t[lang].subjects}</h3>

        <div style={styles.scrollNote}>
          {t[lang].scrollNote}
        </div>

        <div style={styles.tableWrapper}>

          <table style={styles.table}>

            <thead>
            <tr>
              <th style={styles.subjectCol}>
                {t[lang].subject}
              </th>

              {data?.subjects?.[0]?.marks?.map(
                (mark, index) => (
                  <th key={index}>
                    {mark.assessment}
                  </th>
                )
              )}

              <th>{t[lang].average}</th>
              <th>{t[lang].coefficient}</th>
              <th>{t[lang].total}</th>
              
            </tr>
          </thead>

            <tbody>

              {(data?.subjects || []).map((s, i) => (

                <tr key={i}>

                  <td style={styles.subjectCell}>
                    {s.subject}
                  </td>

                  {s.marks?.map((mark, idx) => (

                    <td key={idx}>
                      {mark.score}
                    </td>

                  ))}

                  <td>{s.average}</td>

                  <td>{s.coefficient}</td>

                  <td>{s.weighted_total}</td>

                  

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </div>

      <div style={styles.remarkCard}>
        <h3>{t[lang].teacherRemark}</h3>
        <p>{data.term_remark || "No remark available."}</p>
      </div>

    </div>
  );
}

const styles = {

  page: {
    minHeight: "100vh",
    padding: window.innerWidth < 768 ? "6px" : "17px",
    fontFamily: "Segoe UI",
    background: "linear-gradient(120deg,#e0f2fe,#f0f9ff)"
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "30px",
    flexWrap: "wrap"
  },

  title: {
    fontSize: "28px",
    color: "#1e3a8a"
  },

  honorCard: {
  background: "#fef3c7",
  color: "#92400e",
  padding: "18px",
  borderRadius: "12px",
  marginBottom: "25px",
  textAlign: "center",
  fontWeight: "700",
  fontSize: "18px",
  boxShadow: "0 5px 20px rgba(0,0,0,0.05)"
},

honorText: {
  marginTop: "8px",
  fontSize: "14px",
  fontWeight: "500"
},

  headerControls: {
    display: "flex",
    gap: "10px"
  },

  language: {
    padding: "8px",
    borderRadius: "6px",
    border: "1px solid #cbd5e1"
  },

  studentCard: {
    background: "#ffffff",
    padding: "20px",
    borderRadius: "12px",
    marginBottom: "25px",
    boxShadow: "0 5px 20px rgba(0,0,0,0.05)"
  },

  stats: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))",
    gap: "20px",
    marginBottom: "30px"
  },

  statCard: {
    color: "white",
    padding: "25px",
    borderRadius: "12px",
    textAlign: "center",
    boxShadow: "0 10px 25px rgba(0,0,0,0.1)"
  },

  tableCard: {
    background: "#ffffff",
    padding: "25px",
    borderRadius: "12px",
    marginBottom: "30px",
    boxShadow: "0 5px 20px rgba(0,0,0,0.05)"
  },

  scrollNote: {
    fontSize: "13px",
    color: "#64748b",
    marginBottom: "10px"
  },

  tableWrapper: {
    overflowX: "auto"
  },

  table: {
    width: "100%",
    minWidth: "650px",
    borderCollapse: "collapse",
    textAlign: "center"
  },

  subjectCol: {
    textAlign: "left",
    paddingLeft: "10px"
  },

  subjectCell: {
    textAlign: "left",
    fontWeight: "500",
    paddingLeft: "10px"
  },

  remarkCard: {
    background: "#ffffff",
    padding: "25px",
    borderRadius: "12px",
    boxShadow: "0 5px 20px rgba(0,0,0,0.05)"
  },

  logoutBtn: {
    padding: "8px 18px",
    border: "none",
    borderRadius: "6px",
    background: "#ef4444",
    color: "white",
    cursor: "pointer"
  },

  downloadBtn: {
    padding: "8px 18px",
    border: "none",
    borderRadius: "6px",
    background: "#2563eb",
    color: "white",
    cursor: "pointer"
  },

  warningCard: {
    background: "#fee2e2",
    padding: "40px",
    borderRadius: "12px",
    textAlign: "center"
  },

  loading: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "20px"
  }

};

export default StudentDashboard;